module.exports = __webpack_public_path__ + "img/sub-menu-store.48dbadf6.webp";